export default __webpack_public_path__ + "static/media/payout.c3a2388b.svg";